import React, { Component, Fragment } from "react";
// import {Link} from 'react-router-dom';
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { withFirebase } from "../Firebase";
import { Box, Flex, Image, Text } from "rebass";
import { Avatar } from "reakit";
import { LocationContainer } from "../Base/styles";
import check from "../../resources/img/icons/Checkbox@1x-black.png";
import { schoolActions, schoolSelectors } from "../../store/school";
import { authActions, authSelectors } from "../../store/auth";

import IosCheckmarkCircle from "react-ionicons/lib/IosCheckmarkCircle";

import { CardWrapper } from "./styles";

import stringToColor from "../../utils/stringToColor.js";

const withBorder = {
  pb: [0, 2],
  my: [2, 0],
  borderBottom: `1px solid #DEDDDD`,
};

const noBorderProps = {
  borderBottom: "none",
};

const columnBorderProps = {
  m: 2,
  pb: [0, 2],
  my: [2],
  // width: 170px;
  // height: '170px'
  boxShadow: ["none", "main"],
};

const selectedBorderProps = {
  borderRight: ["none", "7px solid #2b80b9"],
};

class NameCard extends Component {
  state = {
    locations: [],
    history: [],
    map: null,
    details: { first_name: "", last_name: "", location: "", id: 1 },
  };

  componentDidMount() {
    const { details } = this.props;
    this.setState({ details });
    if (details.id.length === 7) {
      this.listener = this.fetchStudentListener(details.id);
    } else {
      this.listener = this.fetchFacultyListener(details.id);
    }
  }

  fetchStudentListener = (id) => {
    return this.props.firebase.student(id).onSnapshot((snapshot) => {
      this.setState({ details: { id: snapshot.id, ...snapshot.data() } });
    });
  };

  fetchFacultyListener = (id) => {
    return this.props.firebase.faculty(id).onSnapshot((snapshot) => {
      this.setState({ details: { id: snapshot.id, ...snapshot.data() } });
    });
  };

  componentWillUpdate(nextProps, nextState, nextContext) {
    if (nextProps.details !== this.props.details) {
      this.setState({ details: nextProps.details });
      if (nextProps.details.id.length === 7) {
        this.listener = this.fetchStudentListener(nextProps.details.id);
      } else {
        this.listener = this.fetchFacultyListener(nextProps.details.id);
      }
    }
    // this.listener = this.fetchStudentListener(details.id)
  }

  componentWillUnmount() {
    this.listener && this.listener();
  }

  render() {
    const { details } = this.state;
    const {
      studentSummary,
      withLocation,
      withHealth,
      noBorder,
      handleClick,
      selected,
      columnView,
      schoolInfo,
      loadingSchool,
      current,
      chatPopupWindow,
    } = this.props;
    let cardProps = withBorder;
    if (noBorder) {
      cardProps = noBorderProps;
    }
    if (!columnView) {
      cardProps = columnBorderProps;
    }
    let locationName = "Unknown";
    let currentDetail = current;
    let status = "transparent";

    // This sets the dot color next to the name
    if (withLocation && details && details.current_location && !loadingSchool) {
      let map = schoolInfo.locations.map;
      // console.log('map', map);
      if (!(details.on_leave && schoolInfo.leaveTypes)) {
        currentDetail = map[details.current_location];
        if (currentDetail) {
          locationName = currentDetail.name;
        }
        if (current && current.is_oncampus) {
          status = "green";
        } else {
          status = "red";
        }
      }
    }

    let is_panic = false;
    if (details && details.is_panic) {
      is_panic = true;
    }

    if (currentDetail === details.id && columnView === true) {
      cardProps = { ...cardProps, ...selectedBorderProps };
    }

    if (!current || !current.is_oncampus) {
      currentDetail = schoolInfo.locations.list.filter(
        (item) => item.id === details.current_location
      )[0];
      status = currentDetail && currentDetail.is_oncampus ? "green" : "red";
    }

    if (details.on_leave && schoolInfo.leaveTypes) {
      locationName = schoolInfo.leaveTypes[details.leave_type].name;
      status = "red";
    }

    // HEALTH
    let today = new Date();
    today.setHours(0, 0, 0, 0);
    let todayEpoch = Math.floor(today.getTime() / 1000);

    let healthLabel = "Loading...";
    let healthLabelColor = "";
    if (withHealth && details) {
      // null or late submission
      if (
        !details.health_last_updated ||
        (details.health_last_updated &&
          details.health_last_updated < todayEpoch)
      ) {
        healthLabel = "UNSUBMITTED";
        healthLabelColor = "#AB80B9";
      }
      // unhealthy
      else if (!details.healthy) {
        healthLabel = "UNHEALTHY";
        healthLabelColor = "#F95050";
      }
      // healthy
      else if (details.healthy) {
        healthLabel = "HEALTHY";
        healthLabelColor = "#2BB99E";
      }
    }

    return (
      <CardWrapper
        minWidth={[
          1 / 3,
          chatPopupWindow ? "50px" : columnView ? "200px" : "153px",
        ]}
        maxWidth={[1 / 3, "200px"]}
        minHeight={[
          1 / 3,
          chatPopupWindow ? "135px" : columnView ? "70px" : "153px",
        ]}
        maxHeight={[1 / 3, columnView ? "70px" : "153px"]}
        style={chatPopupWindow ? { margin: 0 } : {}}
        variant="user"
        onClick={(e) => handleClick && handleClick(details, e)}
        {...cardProps}
      >
        <Flex
          flexWrap={"wrap"}
          flexDirection={["column", columnView ? "row" : "column"]}
        >
          <Flex>
            <Box ml={"auto"} />
            {/*<DesktopBox>*/}
            <IosCheckmarkCircle
              style={{ marginTop: "3px" }}
              color={!columnView && selected ? "#2b80b9" : "white"}
            />
            {/*</DesktopBox>*/}
          </Flex>
          <Box width={[1, "auto"]}>
            <Flex flexDirection={"column"}>
              <Flex justifyContent={"center"}>
                <Avatar
                  src={details.profile_pic}
                  width={"60px"}
                  height={"60px"}
                  backgroundColor={"#707070"}
                />
              </Flex>
            </Flex>
          </Box>
          <Box width={[1, "auto"]} pl={columnView ? 2 : 0}>
            <Text
              textAlign={studentSummary ? "left" : "center"}
              fontSize={studentSummary ? "20px" : "15px"}
              fontWeight="600"
              pt={2}
            >
              {/* <Status bg={status}/> */}
              {details.first_name} {details.last_name}
            </Text>
            {/* {withLocation && <Text color={'meta'} pt={2} ml={studentSummary || columnView ? '15px': 0} fontSize={studentSummary ? '15px': '12px'} fontWeight={600} textAlign={columnView || studentSummary ? 'left' : 'center'}>{locationName}</Text>} */}
            {!is_panic && withLocation && (
              <LocationContainer bg={stringToColor.next(locationName)}>
                {status === "green" ? "ON - " : "OFF - "}
                {locationName}
              </LocationContainer>
            )}
            {withHealth && (
              <LocationContainer bg={healthLabelColor}>
                {healthLabel}
              </LocationContainer>
            )}
            {is_panic && (
              <LocationContainer bg={"#F95050"}>{"PANIC"}</LocationContainer>
            )}
          </Box>
          {selected && columnView && (
            <Fragment>
              <Box ml={"auto"} my={"auto"}>
                <Image src={check} />
              </Box>
            </Fragment>
          )}
        </Flex>
      </CardWrapper>
    );
  }
}

NameCard.propTypes = {
  noBorder: PropTypes.bool,
  withLocation: PropTypes.bool,
  handleClick: PropTypes.func,
  details: PropTypes.object,
  selected: PropTypes.bool,
  columnView: PropTypes.bool,
  rosterList: PropTypes.bool,
  studentSummary: PropTypes.bool,
};

NameCard.defaultProps = {
  noBorder: false,
  withLocation: false,
  selected: false,
  columnView: true,
  studentSummary: false,
};

const mapStateToProps = (state) => ({
  schoolInfo: schoolSelectors.refreshSchool(state.school),
  loadingSchool: schoolSelectors.isLoading(state.school),
  profileInfo: authSelectors.refreshProfile(state.auth),
  loading: authSelectors.isLoading(state.auth),
  isFaculty: authSelectors.isFaculty(state.auth),
});

const mapDispatchToProps = (dispatch) => ({
  updateSchoolInfo: (data) => {
    dispatch(schoolActions.updateSchoolInfo(data));
  },
  updateProfileInfo: (data) => {
    dispatch(authActions.updateProfileInfo(data));
  },
});

export default withFirebase(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(NameCard)
);
